import CorbanForm from "@/components/CorbanForm";
import { Corban, CorbanCreditModalityEnum } from "@/models/corban.model";
import { CreditPromoter } from "@/models/creditPromoter.model";
import { Role } from "@/models/role.model";
import { User } from "@/models/user.model";
import { createCorban, createSplitSolicitation, setCorbanSellerAuthorized } from "@/services/corban.service";
import { getCreditPromoterById } from "@/services/creditPromoter.service";
import { createCreditType } from "@/services/creditType.service";

import { assignCorbanProcessor } from "@/services/processor.service";
import { registerUser } from "@/services/user.service";
import { updateWhiteLabel } from "@/services/whiteLabel.service";
import { removeMask } from "@/utils/removeMask";
// import { ConsoleSqlOutlined } from "@ant-design/icons";
import { useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function CreateCorbanPage() {
  // const [financialSettings, setFinancialSettings] = useState<FinancialSettings | null>(null);
  const [creditPromoter, setCreditPromoter] = useState<CreditPromoter | null>(null)
  const [fgtsPermission, setFgtsPermission] = useState<boolean>(false)
  const [consignadoPermission, setConsignadoPermission] = useState<boolean>(false)
  const [commercialManagerId, setCommercialManagerId] = useState<string | null>(null)
  const navigate = useNavigate();

  const toast = useToast();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const creditPromoterId = searchParams.get("creditPromoterId");

  useEffect(() => {
    // const fetchFinancialSettings = async () => {
    const fetchCreditPromoter = async () => {

      if (creditPromoterId) {
        // console.log('CREATECORBAN creditPromoterId', creditPromoterId)
        try {
          // const settings = await getFinancialSettingsByCreditPromoterId(creditPromoterId);
          // setFinancialSettings(settings);
          // console.log('settings', settings)
          const creditPromoter = await getCreditPromoterById(parseInt(creditPromoterId))
          setCreditPromoter(creditPromoter);

          const fgtsPermission = creditPromoter?.CreditTypeCorbans?.find((p: any) => p.credit_type === CorbanCreditModalityEnum.FGTS);
          setFgtsPermission(fgtsPermission?.enable!)

          const consigPermission = creditPromoter?.CreditTypeCorbans?.find((p: any) => p.credit_type === CorbanCreditModalityEnum.CONSIG_WORKER);
          setConsignadoPermission(consigPermission?.enable!)
          const commercialManagerId = creditPromoter?.FinancialSettings?.commercialManagerId;
          // console.log('creditPromoter', creditPromoter)
          setCommercialManagerId(commercialManagerId!)
          // const financialSettingsFgts = creditPromoter?.FinancialSettingsCorbansAndCreditPromoter?.find(financialSettings => financialSettings.creditType === CorbanCreditModalityEnum.FGTS)
          // setFgtsFinancialSettings(financialSettingsFgts?.FinancialSettings!)

          // const financialSettingsConsignado = creditPromoter?.FinancialSettingsCorbansAndCreditPromoter?.find(financialSettings => financialSettings.creditType === CorbanCreditModalityEnum.CONSIG_WORKER)
          // setConsignadoFinancialSettings(financialSettingsConsignado?.FinancialSettings!)

          // console.log('financialSettingsConsignado', financialSettingsConsignado)
          // console.log('financialSettingsFgts', financialSettingsFgts)
        } catch (error) {
          // console.error("Error fetching financial settings:", error);
          console.error("Error fetching credit promoter:", error);
        }
      }
    };

    fetchCreditPromoter();
    // fetchFinancialSettings();

  }, [creditPromoterId]);

  const initialValues = {
    paymentSplit: false,
    document: undefined,
    commission: undefined,
    legalName: undefined,
    businessName: undefined,
    automaticApproval: false,
    creditPromoterId: creditPromoterId ? Number(creditPromoterId) : undefined,
    financialSettingsId: undefined,
    financialSettingsConsignadoId: undefined,
    products: [],
    masterUserName: undefined,
    masterUserLastName: undefined,
    masterUserPhone: "",
    masterUserEmail: undefined,
    masterUserCpf: "",
    masterUserRole: [] as Role[],
    masterUserPassword: undefined,
    masterCorbanId: undefined,
    whiteLabelId: undefined,
    commercialManagerId:creditPromoterId ? creditPromoter?.FinancialSettings?.commercialManagerId : undefined,
    fgtsApikey: undefined,
    fgtsWebhookUrl: undefined,
    consigApikey: undefined,
    consigWebhookUrl: undefined,
    isFGTSEnable: fgtsPermission ? fgtsPermission : undefined,
    isFGTSEnablePromoter: fgtsPermission ? fgtsPermission : undefined,
    isFGTSApiEnable: undefined,
    fgtsToken: undefined,
    isConsigApiEnable: undefined,
    isConsigEnable: consignadoPermission ? consignadoPermission : undefined,
    isConsigEnablePromoter: consignadoPermission ? consignadoPermission : undefined,
    consigToken: undefined,
    consigProducts: [],
    sellerAuthorized: undefined,
    creditPromoter: creditPromoter
  };

  const handleSubmit = async (values: typeof initialValues) => {
    const cleanedCNPJ = removeMask(values.document || "");
    const cleanedCpf = removeMask(values.masterUserCpf);
    const cleanedPhone = removeMask(values.masterUserPhone);
    const cleanedSellerAuthorized = values.sellerAuthorized ? removeMask(values.sellerAuthorized) : null;
    let corban: Corban | undefined;

    try {
      const corbanData = {
        document: cleanedCNPJ,
        legalName: values.legalName,
        businessName: values.businessName,
        automaticApproval: values.automaticApproval,
        financialSettingsId: values.financialSettingsId,
        creditPromoterId: values.creditPromoterId,
        commission: values.commission,
        products: values.products,
        masterName: `${values.masterUserName} ${values.masterUserLastName}`,
        paymentSplit: values.paymentSplit,
        sellerAuthorized: cleanedSellerAuthorized,
      };

      corban = await createCorban(corbanData);

      if (corban && corban.id) {
        await assignCorbanProcessor(corban.id);
      }

      if (corban && corban.id && cleanedSellerAuthorized) {
        try {
          await setCorbanSellerAuthorized(corban.id, cleanedSellerAuthorized);
        } catch (error) {
          console.error("Erro ao definir vendedor autorizado:", error);
        }
      }

      if (corban && corban.paymentSplit && corban.id) {
        try {
          await createSplitSolicitation(corban.id);
        } catch (error) {
          console.error("Erro ao criar solicitação de split:", error);
        }
      }

      const userData: Partial<User> = {
        name: values.masterUserName,
        lastName: values.masterUserLastName,
        document: cleanedCpf,
        cellphone: cleanedPhone,
        corbanId: corban.id,
        roles: values.masterUserRole,
        creditPromoterId: values.creditPromoterId,
        email: values.masterUserEmail,
        password: values.masterUserPassword,
      };

      await registerUser(userData);

      // if (createdUser) {
      //   await createSelfService({
      //     userId: createdUser.id,
      //     corbanId: createdUser.corbanId!,
      //     slug: createSlug(`${createdUser.name} ${createdUser.lastName}`),
      //     name: `${createdUser.name} ${createdUser.lastName}`,
      //     isUserCampaign: true,
      //   });
      // }

      if (values.whiteLabelId) {
        await updateWhiteLabel(values.whiteLabelId, {
          corbanId: corban.id,
          name: corban.businessName,
        });
      }

      await createCreditType({
        corbanId: corban.id,
        credit_type: CorbanCreditModalityEnum.FGTS,
        api_enable: values?.isFGTSApiEnable ?? false,
        enable: values?.isFGTSEnable ?? false,
        userCanAccess: values?.isFGTSEnable ? 'all' : ''
      });

      await createCreditType({
        corbanId: corban.id,
        credit_type: CorbanCreditModalityEnum.CONSIG_WORKER,
        api_enable: values?.isConsigApiEnable ?? false,
        enable: values?.isConsigEnable ?? false,
        userCanAccess: values?.isConsigEnable ? 'all' : ''
      });


      // await updateCorbanProduct(corban?.id!, {
      //   consig_products: values?.consigProducts,
      //   fgts_products: values?.products,
      // });

      // if (values?.isFGTSEnable && values?.isFGTSApiEnable && values?.fgtsWebhookUrl) {
      //   const body = {
      //     webhook_fgts: values?.fgtsWebhookUrl!,
      //     corban_id: corban?.id!,
      //     granatech_user_id: createdUser.id!,
      //     granatech_password_id: values?.masterUserPassword!,
      //     token: values?.fgtsToken
      //   }
      //   await createUserApiFGTS(body)
      // }

      // if (values?.isConsigEnable && values?.isConsigApiEnable && values?.consigWebhookUrl) {
      //   const body = {
      //     webhook_consignado: values?.consigWebhookUrl!,
      //     corban_id: corban?.id!,
      //     granatech_user_id: createdUser.id!,
      //     granatech_password_id: values?.masterUserPassword!,
      //     token: values?.consigToken
      //   }

      //   await createUserApiConsig(body)
      // }

      // if (values?.financialSettingsConsignadoId) {
      //   try {
      //     await associateFinancialSettings({
      //       financialSettingsId: values.financialSettingsConsignadoId,
      //       creditType: CorbanCreditModalityEnum.CONSIG_WORKER,
      //       corbanId: corban?.id,
      //       creditPromoterId: corban?.CreditPromoter?.id
      //     });
      //   } catch (error) {
      //     console.error("Erro ao associar financial settings:", error);
      //   }
      // }

      // if (values?.financialSettingsId) {
      //   try {
      //     await associateFinancialSettings({
      //       financialSettingsId: values.financialSettingsId,
      //       creditType: CorbanCreditModalityEnum.FGTS,
      //       corbanId: corban?.id,
      //       creditPromoterId: corban?.CreditPromoter?.id
      //     });
      //   } catch (error) {
      //     console.error("Erro ao associar financial settings do FGTS:", error);
      //   }
      // }

      toast({
        title: `Corban cadastrado com sucesso`,
        description: `Corban ${corban.businessName} foi cadastrado!`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      navigate(-1);
    } catch (error: any) {
      console.error("Erro na criação do Corban:", error);
      // if (corban?.id) await deleteCorban(corban?.id);

      toast({
        title: "Erro ao salvar Corban",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <CorbanForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isNew={true}
      commercialManagerId={
        commercialManagerId
      }

      creditPromoterId={creditPromoterId ? Number(creditPromoterId) : undefined}
    />
  );
}
